<template>
    <div class="ba6-account-settings ba-app-content">
      <ba6-layout-settings :view="view" :routes="routes" :t="view.translation" :callback="setComponentStatus" >
        <KeepAlive>
          <!-- Account Info -->
          <ba6-account-info
            v-if="getRouteStatus('account-info')"
            :accountInfo="view.account_info"
            :langs="view.langs"
            :timezones="view.timezones"
            :routes="view.handler_routes"
            :t="view.translation"
          />

          <!-- Security -->
          <ba6-security
            v-if="getRouteStatus('security')"
            :accountInfo="view.account_info"
            :routes="view.handler_routes"
            :securityData="view.security_data"
            :t="view.translation"
            :popup="view.popup"
            :openPasswordReset="open_password_reset"
          />

          <!-- Invoices -->
          <ba6-invoices
            v-if="getRouteStatus('invoices')"
            :invoicesData="view.invoices_data"
            :view="view"
          />

          <!-- Quotas -->
          <ba6-quotas
            v-if="getRouteStatus('quotas')"
            :routes="view.handler_routes"
            :quotas="view.quotas"
            :accountInfo="view.account_info"
            :t="view.translation"
          />

          <!-- Affiliation -->
          <ba6-affiliation
            v-if="getRouteStatus('affiliation')"
            :routes="view.handler_routes"
            :affiliation="view.affiliation"
            :t="view.translation"
            :hasSalesIn90Days="view.hasSalesIn90Days"
          />

          <!-- MailingBoss -->
          <ba6-mailingboss
            v-if="getRouteStatus('mailingboss')"
            :routes="view.handler_routes"
            :accountInfo="view.account_info"
            :mb="view.mailingboss"
            :t="view.translation"
          />
        </KeepAlive>
      </ba6-layout-settings>
    </div>
</template>

<script>
    export default {
      name: "ba6-account-settings",
      props: ['view'],
      data() {
        return {
          routes: [
            { route: 'account-info', title: this.view.translation.office2_geral_edit_info, status: true },
            { route: 'security', title: this.view.translation.security, status: false },
            { route: 'invoices', title: this.view.translation.label_invoices, status: false },
            { route: 'quotas', title: this.view.translation.plan_limits, status: false },
            { route: 'affiliation', title: this.view.translation.label_affiliation, status: false },
            { route: 'mailingboss', title: this.view.translation.tags, status: false },
          ],
          open_password_reset: false
        }
      },
      created() {
        this.mountRoutes()
      },
      mounted() {
        let params = new URLSearchParams(document.location.search);
        if(params.get('showPasswordResetPopup') === "true") {
          this.setComponentStatus('security')
          this.open_password_reset = true
        }
      },
      methods: {
        mountRoutes() {
          if(this.view.tab)
          {
            this.routes.find(x => x.route == this.view.tab ? x.status = true : x.status = false)
          }

          if(this.view.profile_info.isva)
          {
            let index = this.routes.findIndex(x => x.route == 'invoices')
            this.routes.splice(index, 1)
          }

          if(!this.view.profile_info.father_is_builderall)
          {
            let index = this.routes.findIndex(x => x.route == 'quotas')
            this.routes.splice(index, 1)
          }
        },
        getRouteStatus(route) {
          let index = this.routes.findIndex(x => x.route === route)
          return index != -1 ? this.routes[index].status : false
        },
        getComponentStatus(name) {
          return this.routes[this.routes.findIndex(x => x.route == name)].status
        },
        setComponentStatus(name) {
          this.routes.forEach(x => {
            x.status = name === x.route
          })
        }
      },
    }
</script>

<style scoped lang="scss">
  .ba6-account-settings{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/Index.vue